import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Landing from '../../components/Landing/Landing';
import Footer from '../../components/Footer/Footer';

import { media } from '../../utilities/style-utilities';

import SessionStorage from '../../storage/SessionStorage/SessionStorage';

const StyledHeader = styled(Header)`
  display: none;
  ${ media.desktop`
    display: flex;
  `}
`;

class LandingPage extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    this.props.update({
      cardActivation: {
        activeStep: 1,
          error: {
              isVisible: false,
              message: ''
          }
      },
      pinRetrieval: {
        activeStep: 1,
          error: {
              isVisible: false,
              message: ''
          }
      }
    });
    SessionStorage.clearSessionStorage();
  }

    render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.appState.ui.landing.meta.title}</title>
          <meta name="description" content={this.props.appState.ui.landing.meta.description} />
        </Helmet>
        <StyledHeader header={this.props.appState.ui.header} url={this.props.url}/>
        <Main site={this.props.appState.ui.site} landing>
          <Landing landing={this.props.appState.ui.landing} url={this.props.url} />
        </Main>
        <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms} />
      </Fragment>
    )
  }
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/containers/LandingPage/LandingPage.js